import cn from 'classnames';
import CheckButton from './../../../global/CheckButton/CheckButton'; // Componentes
import './OptionItem.css'; // CSS

function OptionItem({id, value, mark, onClick}) {
    return (
        <div className={cn("option-item", {"option-item--mark": mark})} onClick={onClick} key={id}>
            <CheckButton
                check={mark}
                width={17}
                borderColor="#ac4b1c55"
                backgroundColor="#ac4b1c" />

            <span className="option-item__value">{value}</span>
        </div>
    );
}

export default OptionItem;